import axios from 'axios';
import env from '../environments/env';
import './interceptor';

export const Get = async (url, params, config, apiUrl = env.API_URL) => {
  try {
    const res = await axios.get(`${apiUrl}/${url}`, {
      params,
      ...config,
      credentials: true
    });
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const Post = async (url, body, config, apiUrl = env.API_URL) => {
  try {
    const res = await axios.post(`${apiUrl}/${url}`, body, config);
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const Put = async (url, body, config, apiUrl = env.API_URL) => {
  try {
    const res = await axios.put(`${apiUrl}/${url}`, body, config);
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const Delete = async (url, body, config, apiUrl = env.API_URL) => {
  try {
    const res = await axios.delete(`${apiUrl}/${url}`, body, config);
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const handleErrorResponse = (err) => {
  console.log(err);
  const { response = {}, message } = err;
  const { status = null, statusText = null, data = {} } = response;
  let error = {
    status,
    statusText,
    data
  };

  if (message === 'Network Error') {
    error = {
      ...error,
      error: 'network'
    };
    return error;
  }

  if (status === 401) {
    error = {
      ...error,
      error: 'unauthorized'
    };
    return error;
  }

  if (status === 400) {
    error = {
      ...error,
      error: 'badrequest'
    };
    return error;
  }

  error = {
    ...error,
    error: 'server'
  };

  return error;
};
